import React, { useState, useEffect } from "react";
import "react-pro-sidebar/dist/css/styles.css";
import { logColor } from "../../../../theme";
import ApexCharts from "react-apexcharts";


const LinearGraph = ({ responseApi, filter }) => {
  const [type0, setType0] = useState(0);
  const [type1, setType1] = useState(0);
  const [type2, setType2] = useState(0);
  const [type3, setType3] = useState(0);



   
  useEffect(() => {
    if (responseApi) {
      let HighType = responseApi.filter((msg) => msg._id.tipo === 0)
      const valueHigh = HighType.reduce((accumulator, item) => {
        return accumulator + Number(item.count);
      }, 0);
      setType0(valueHigh);
      let CriticalType = responseApi.filter((msg) => msg._id.tipo === 1)
      const valueCritical = CriticalType.reduce((accumulator, item) => {
        return accumulator + Number(item.count);
      }, 0);
      setType1(valueCritical);
      let AlertType = responseApi.filter((msg) => msg._id.tipo === 2)
      const valueAlert = AlertType.reduce((accumulator, item) => {
        return accumulator + Number(item.count);
      }, 0);
      setType2(valueAlert);
      let AnomaliesType = responseApi.filter((msg) => msg._id.tipo === 3)
      const valueAnomalies = AnomaliesType.reduce((accumulator, item) => {
        return accumulator + Number(item.count);
      }, 0);
      setType3(valueAnomalies);
    } 
  }, [responseApi]);

  

const options={
  chart: {
    type: 'bar',
    height: 380
  },
  plotOptions: {
    bar: {
      barHeight: '100%',
      distributed: true,
      horizontal: true,
      dataLabels: {
        position: 'bottom'
      },
    }
  },
  colors: [logColor[1], logColor[0], logColor[2], logColor[3]],
  dataLabels: {
    enabled: true,
    textAnchor: 'start',
    style: {
      colors: ['#fff']
    },
    formatter: function (val, opt) {
      return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
    },
    offsetX: 0,
    dropShadow: {
      enabled: true
    }
  },
  stroke: {
    width: 1,
    colors: ['#fff']
  },
  xaxis: {
    categories: ['Critical', 'High', 'Alert', 'Movements'],
  },
  yaxis: {
    labels: {
      show: false
    }
  },
  tooltip: {
    theme: 'dark',
    x: {
      show: false
    },
    y: {
      title: {
        formatter: function () {
          return ''
        }
      }
    }
  }
}


const series = [{
  data: [type1, type0, type2, type3]
}]


  return (
    <div style={{ width: '100%', height: '100%', padding: 0, margin: 0 }}>
      <ApexCharts options={options} series={series} type="bar" height={"100%"}/>
    </div>
  );
};

export default LinearGraph;